import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { IoMdEye, IoMdEyeOff } from "react-icons/io";
import { ToastContainer, toast } from 'react-toastify';

import _constantUtil from '../utils/Constant';
import Loader from '../components/partials/Loader';
import config from '../config/config';
import mobileBar from '../assets/images/232213.jpg'

const {
    BOOLEAN_FALSE: falseValue,
    BOOLEAN_TRUE: trueValue,
    EMPTY_STRING: emptyString,
    SEND_OTP_END_POINT,
} = _constantUtil;

function Login() {
    const [email, setEmail] = useState(emptyString);
    const [password, setPassword] = useState(emptyString);
    const [loading, setLoading] = useState(falseValue);
    const [otpSent, setOtpSent] = useState(falseValue);
    const [disableButton, setDisableButton] = useState(falseValue);
    const [visibility, setVisibility] = useState(falseValue);
    const [error, setError] = useState({});
    const navigate = useNavigate();

    //* navigate to email verification
    useEffect(() => {
        if (otpSent) {
            navigate('/verify-otp', { state: { email, password } });
        }
    }, [otpSent, navigate, email, password]);

    //* execute send otp api
    function executeSendOTPapi(event) { 
        event.preventDefault();
        setLoading(trueValue);
        setDisableButton(trueValue)
        const data = { email, password };

        //* api url
        const apiUrl = config.appBaseUrl + SEND_OTP_END_POINT;

        //* send otp
        axios.post(apiUrl, data, {
            headers: {
                'Content-Type': 'application/json',
            },
        }).then(res => {
            const result = res.data;
            if (result.status) {
                toast.success(result.message)
                setTimeout(() => {
                    setOtpSent(trueValue);
                    setLoading(falseValue);
                    setDisableButton(falseValue);
                }, 2000);
            } else {
                toast.error(result.message)
                setLoading(falseValue);
                setDisableButton(falseValue);
            }
        }).catch(error => { 
            setError(error?.response?.data?.data)
            setLoading(falseValue);
            setDisableButton(falseValue);
        });
    }

    return (
        <>
            <ToastContainer autoClose={1000} position='top-center' />
            <div className="grid">
                <div className="order__left centered d-flex align-items-center justify-content-center">
                    <form onSubmit={executeSendOTPapi}>
                        <div className="logo">
                            <h3 className='text-center'>Hire a Vendor for professionals</h3>
                        </div>
                        <div className="d-flex align-items-center justify-content-center">
                            <p className='text-center'>Securely log in to manage and grow your business.</p>
                        </div>
                        <div>
                            <input
                                type="text"
                                id="username"
                                name="username"
                                placeholder="Email"
                                autoComplete="off"
                                className='mb-0'
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                            {error.email && <p className='ps-1' style={{ color: 'red', fontSize: '0.8rem' }}>*{error.email[0]}</p>}
                        </div>
                        <div style={{ position: 'relative' }}>
                            <input
                                type={visibility ? 'text' : 'password'}
                                id="password"
                                name="password"
                                placeholder="Password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className='mb-0'
                                autoComplete="off"
                            />
                            <button
                                type="button"
                                onClick={() => setVisibility((prev) => !prev)}
                                style={{
                                    position: 'absolute',
                                    right: '10px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    background: 'none',
                                    border: 'none',
                                    cursor: 'pointer',
                                }}
                            >
                                {visibility ? <IoMdEyeOff size={18} /> : <IoMdEye size={18} />}
                            </button>
                        </div>
                        {error.password && <p className='ps-1' style={{ color: 'red', fontSize: '0.8rem' }}>*{error.password[0]}</p>}
                        <div className="justify__space_between  float-end mt-0">
                            <Link to="/forgot-password" className="forgot__password text-golden mt-3">
                                Forgot Password?
                            </Link>
                        </div>
                        <button type="submit" className="login__button" 
                            disabled={disableButton}
                        >
                            {!loading ? 'Login' : <Loader />}
                        </button>
                    </form>
                </div>
                <div className="order__right centered no__overflow d-none d-md-block">
                    <img
                        className="img"
                        src={mobileBar}
                        alt="picture"
                    />
                </div>
            </div>
        </>
    );
}

export default Login;